define("calendar/components/carousel-tutorial", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service", "@glimmer/tracking"], function (_exports, _component, _templateFactory, _component2, _object, _service, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.isVisible}}
    <Shared::Wizard
      @onFinish={{this.receiveEducation}}
      as
      |wizard|
    >
      <wizard.slide
        as
        |slide|
      >
        <slide.body>
          <section class="tOB--wizard tOB--image__carousel">
            {{!-- Image --}}
            <div class="tOB--wizard__left">
            </div>
            {{!-- Description --}}
            <div class="tOB--wizard__right">
              <h3 class="tOB--wizard__title">
                {{t "tutorials.multi_image.intro.title"}}
              </h3>
              {{#if this.canAutoPublish}}
                {{html-safe (t "tutorials.multi_image.intro.can_auto")}}
              {{else}}
                {{html-safe (t "tutorials.multi_image.intro.cannot_auto")}}
              {{/if}}
            </div>
          </section>
        </slide.body>
        <slide.footer @onCancel={{this.closeTutorial}} />
      </wizard.slide>
      <wizard.slide
        @skip={{this.hasDevices}}
        as
        |slide|
      >
        <slide.body>
          <Shared::Wizards::DeviceSetup::StepOne />
        </slide.body>
        <slide.footer>
          <slide.previousButton />
          <slide.nextButton
            @isDisabled={{not this.hasDevices}}
            @text={{t "shared_words.continue"}}
          />
        </slide.footer>
      </wizard.slide>
      <wizard.slide
        @skip={{this.hasDevices}}
        as
        |slide|
      >
        <slide.body>
          <Shared::Wizards::DeviceSetup::StepTwo />
        </slide.body>
        <slide.footer />
      </wizard.slide>
      <wizard.slide
        as
        |slide|
      >
        <slide.body>
          <Shared::Wizards::Carousel::StepOne
            @canAutoPublish={{this.canAutoPublish}}
          />
        </slide.body>
        <slide.footer />
      </wizard.slide>
      <wizard.slide
        as
        |slide|
      >
        <slide.body>
          <Shared::Wizards::Carousel::StepTwo />
        </slide.body>
        <slide.footer />
      </wizard.slide>
      <wizard.slide
        as
        |slide|
      >
        <slide.body>
          <Shared::Wizards::Carousel::StepThree
            @educationBoxChecked={{this.educationBoxChecked}}
            @canAutoPublish={{this.canAutoPublish}}
          />
        </slide.body>
        <slide.footer
          @isDisabled={{not this.educationBoxChecked}}
          @finishButtonText={{t "tutorials.multi_image.slide_3.agree_button"}}
          @finishWizard={{this.receiveEducation}}
        />
      </wizard.slide>
    </Shared::Wizard>
  {{/if}}
  
  */
  {
    "id": "xKraWLT0",
    "block": "[[[41,[30,0,[\"isVisible\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@onFinish\"],[[30,0,[\"receiveEducation\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"slide\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[30,2,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[10,\"section\"],[14,0,\"tOB--wizard tOB--image__carousel\"],[12],[1,\"\\n\"],[1,\"          \"],[10,0],[14,0,\"tOB--wizard__left\"],[12],[1,\"\\n          \"],[13],[1,\"\\n\"],[1,\"          \"],[10,0],[14,0,\"tOB--wizard__right\"],[12],[1,\"\\n            \"],[10,\"h3\"],[14,0,\"tOB--wizard__title\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"tutorials.multi_image.intro.title\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"],[41,[30,0,[\"canAutoPublish\"]],[[[1,\"              \"],[1,[28,[35,3],[[28,[37,2],[\"tutorials.multi_image.intro.can_auto\"],null]],null]],[1,\"\\n\"]],[]],[[[1,\"              \"],[1,[28,[35,3],[[28,[37,2],[\"tutorials.multi_image.intro.cannot_auto\"],null]],null]],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,2,[\"footer\"]],null,[[\"@onCancel\"],[[30,0,[\"closeTutorial\"]]]],null],[1,\"\\n    \"]],[2]]]]],[1,\"\\n    \"],[8,[30,1,[\"slide\"]],null,[[\"@skip\"],[[30,0,[\"hasDevices\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,3,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,4],null,null,null],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,3,[\"footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,3,[\"previousButton\"]],null,null,null],[1,\"\\n        \"],[8,[30,3,[\"nextButton\"]],null,[[\"@isDisabled\",\"@text\"],[[28,[37,5],[[30,0,[\"hasDevices\"]]],null],[28,[37,2],[\"shared_words.continue\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[3]]]]],[1,\"\\n    \"],[8,[30,1,[\"slide\"]],null,[[\"@skip\"],[[30,0,[\"hasDevices\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,4,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,6],null,null,null],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,4,[\"footer\"]],null,null,null],[1,\"\\n    \"]],[4]]]]],[1,\"\\n    \"],[8,[30,1,[\"slide\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[30,5,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,7],null,[[\"@canAutoPublish\"],[[30,0,[\"canAutoPublish\"]]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,5,[\"footer\"]],null,null,null],[1,\"\\n    \"]],[5]]]]],[1,\"\\n    \"],[8,[30,1,[\"slide\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[30,6,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,8],null,null,null],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,6,[\"footer\"]],null,null,null],[1,\"\\n    \"]],[6]]]]],[1,\"\\n    \"],[8,[30,1,[\"slide\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[30,7,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,9],null,[[\"@educationBoxChecked\",\"@canAutoPublish\"],[[30,0,[\"educationBoxChecked\"]],[30,0,[\"canAutoPublish\"]]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,7,[\"footer\"]],null,[[\"@isDisabled\",\"@finishButtonText\",\"@finishWizard\"],[[28,[37,5],[[30,0,[\"educationBoxChecked\"]]],null],[28,[37,2],[\"tutorials.multi_image.slide_3.agree_button\"],null],[30,0,[\"receiveEducation\"]]]],null],[1,\"\\n    \"]],[7]]]]],[1,\"\\n  \"]],[1]]]]],[1,\"\\n\"]],[]],null]],[\"wizard\",\"slide\",\"slide\",\"slide\",\"slide\",\"slide\",\"slide\"],false,[\"if\",\"shared/wizard\",\"t\",\"html-safe\",\"shared/wizards/device-setup/step-one\",\"not\",\"shared/wizards/device-setup/step-two\",\"shared/wizards/carousel/step-one\",\"shared/wizards/carousel/step-two\",\"shared/wizards/carousel/step-three\"]]",
    "moduleName": "calendar/components/carousel-tutorial.hbs",
    "isStrictMode": false
  });

  let CarouselTutorialComponent = (_class = class CarouselTutorialComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "onboarding", _descriptor2, this);

      _initializerDefineProperty(this, "router", _descriptor3, this);

      _initializerDefineProperty(this, "segment", _descriptor4, this);

      _initializerDefineProperty(this, "mediaLibrary", _descriptor5, this);

      _initializerDefineProperty(this, "educationBoxChecked", _descriptor6, this);
    }

    get canAutoPublish() {
      return this.auth.currentAccount.canIgCarouselAutoPublish;
    }

    get isVisible() {
      return !this.auth.currentUserModel.receivedMultiImageEducation && this.mediaLibrary.selectedMedia.length > 1;
    }

    get hasDevices() {
      return this.auth.hasDevices;
    }

    receiveEducation() {
      this.auth.currentUserModel.receivedMultiImageEducation = true;
      this.auth.currentUserModel.save();
      this.segment.track('completed-multi-image-web-tutorial');
    }

    closeTutorial() {
      this.onboarding.confirmClose().then(() => this.router.transitionTo('cluster.schedule.calendar'));
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "mediaLibrary", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "educationBoxChecked", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "receiveEducation", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "receiveEducation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeTutorial", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeTutorial"), _class.prototype)), _class);
  _exports.default = CarouselTutorialComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CarouselTutorialComponent);
});